import "./App.css";
import "./Styles/fontfamily.css";

import NavbarComp from "./Component/NavbarComp";
import { FooterComp } from "./Component/FooterComp";

import MainRoutes from "./Pages/MainRoutes";
import GdprModal from "./Pages/GDPRModal";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
function App() {

   const [showFooter, setShowFooter] = useState(false);
 const location = useLocation();
 const hideNavAndFooter = location.pathname === '/subscribe';
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFooter(true);
    }, 2000); // 2 seconds
    return () => clearTimeout(timer); // cleanup on unmount
  }, []);
  
  return (
    <>
      {/* <NavbarComp /> */}
       {!hideNavAndFooter && <NavbarComp />}
      <GdprModal />
      <MainRoutes />
       {!hideNavAndFooter && showFooter && <FooterComp />}
      {/* <FooterComp /> */}
    </>
  );
}

export default App;
